/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { withLeaflet, MapLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet-geotiff";
import "leaflet-geotiff/leaflet-geotiff-plotty";

class GeotiffLayer extends MapLayer {
  // eslint-disable-next-line class-methods-use-this
  createLeafletElement(props) {
    const { url, options } = props;
    return L.leafletGeotiff(url, options);
  }

  componentDidMount() {
    const { map } = this.props.leaflet;
    const { name } = this.props;
    const { options } = this.props;
    const Layer = this.leafletElement.addTo(map);
    Layer.setStyle({
      opacity: options.opacity ? options.opacity : 0.5,
    });
    // const control = L.control
    //   .layers(null, null, {
    //     collapsed: false,
    //     position: "topleft",
    //     hideSingleBase: true,
    //   })
    //   .addTo(map);
    // control.addOverlay(Layer, name);
    // if (name === 'Acc. Fcst. Rain 1 Day') map.removeLayer(Layer);
    if (name === "Acc. Obs. Rain 5 Day") map.removeLayer(Layer);
  }
}

// eslint-disable-next-line import/prefer-default-export
export const PlottyGeotiffLayer = withLeaflet((props) => {
  const { options, layerRef } = props;
  // eslint-disable-next-line global-require
  const plotty = require("plotty");
  plotty.addColorScale(
    "fcstRaincolorscale",
    [
      "#FFFFFF",
      "#CBE3FF",
      "#AED3FF",
      "#97E5AB",
      "#6AC805",
      "#F9D601",
      "#FD8B02",
      "#CC6602",
      "#FE3003",
      "#FE3003",
      "#881A1B",
      "#9630D1",
    ],
    [0, 0.01, 0.02, 0.04, 0.07, 0.1, 0.14, 0.18, 0.3, 0.4, 0.6, 1]
  );
  // plotty.addColorScale('obsRaincolorscale', ['#e7f4b5', '#e19c51', '#e15153', '#6267f0', '#272ae8', '#232b78'], [0.09, 0.30, 0.2, 0.2, 0.8, 1]);
  plotty.addColorScale(
    "obsRaincolorscale",
    ["#e7f4b5", "#e19c51", "#e15153", "#6267f0", "#272ae8", "#232b78"],
    [0, 0.2, 0.6, 0.8999, 0.7, 1]
  );

  options.renderer = new L.LeafletGeotiff.Plotty(options);
  return <GeotiffLayer ref={layerRef} {...props} />;
});


export const RRIGeotiffLayer = withLeaflet((props) => {
  const { options, layerRef } = props;
  // eslint-disable-next-line global-require
  const plotty = require("plotty");

  plotty.addColorScale(
    "qrSpatialColorscale",
    [
      "#FFFFFF",
      "#E1F5FE",
      "#81D4FA",
      "#29B6F6",
      "#1976D2",
      "#5E35B1",
      "#8E24AA",
      "#C2185B",
      "#E53935",
      "#F4511E",
      "#E64A19",
      "#D32F2F",
      "#B71C1C",
      "#7F0000",
    ],
    [0, 0.1 / 4000, 50 / 4000, 150 / 4000, 350 / 4000, 550 / 4000, 750 / 4000, 1000 / 4000, 1250 / 4000, 1500 / 4000, 1800 / 4000, 2100 / 4000, 2400 / 4000, 1]
  );

  options.renderer = new L.LeafletGeotiff.Plotty(options);
  return <GeotiffLayer ref={layerRef} {...props} />;
});

export const FFPIGeotiffLayer = withLeaflet((props) => {
  const { options, layerRef } = props;
  const plotty = require("plotty");

  // displayMin=0, displayMax=5 → normalize ด้วย /5
  // < 2.40  → ขาว (โปร่งใส)
  // 2.40–3.35 → เขียว
  // 3.35–4.35 → เหลือง
  // > 4.35  → แดง
  plotty.addColorScale(
    "ffpiColorscale",
    [
      "#FFFFFF",  // 0.00 → ขาว
      "#FFFFFF",  // 2.40/5 = 0.480 → ขาว (ขอบบน)
      "#4CAF50",  // 2.40/5 + ε → เขียว (เริ่ม)
      "#4CAF50",  // 3.35/5 = 0.670 → เขียว (ขอบบน)
      "#FFEB3B",  // 3.35/5 + ε → เหลือง (เริ่ม)
      "#FFEB3B",  // 4.35/5 = 0.870 → เหลือง (ขอบบน)
      "#F44336",  // 4.35/5 + ε → แดง (เริ่ม)
      "#F44336",  // 1.00 → แดง
    ],
    [0, 0.480, 0.481, 0.670, 0.671, 0.870, 0.871, 1.0]
  );

  options.renderer = new L.LeafletGeotiff.Plotty(options);
  return <GeotiffLayer ref={layerRef} {...props} />;
});